import script from "./CustomizationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizationBlock.vue?vue&type=script&setup=true&lang=js"

import "./CustomizationBlock.vue?vue&type=style&index=0&id=77488600&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77488600"]])

export default __exports__